import React, { Component } from 'react';

import rs, { KJUR } from 'jsrsasign';
import DecisioningAuth from './decisioningAuth';

export class FakeCognitoAuth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: 'qaa_underwriter+cpf@projecteagle.cc',
    };
  }

  async setupFakeJWT() {
    const time = Math.floor(Date.now() / 1000);

    let rawPrvKey = await (await fetch('/fake-cognito-pool/jwtRS256.key')).text();
    let prvKey = rs.KEYUTIL.getKey(rawPrvKey);

    // Sign JWT, password=616161
    let sHeader = JSON.stringify({ alg: 'RS256', typ: 'JWT', kid: '1' });
    let sPayload = JSON.stringify({
      iss: 'http://host.docker.internal:3001/fake-cognito-pool/',
      aud: 'switch-users',
      iat: time,
      exp: time + 720000000,
      email: this.state.username,
      jti: 'id123456',
      'cognito:groups': this.state.username.includes('nogroup') ? ['google_default_group'] : ['underwriter'],
    });
    let sJWT = KJUR.jws.JWS.sign('RS256', sHeader, sPayload, prvKey);

    console.log('sJWT', sJWT);

    new DecisioningAuth().storeDefaultRedirect().idToken = sJWT;
    window.location.href = `/cognito-auth/#id_token=${sJWT}`;
  }

  render() {
    return (
      <div className="fake-cognito-auth-page content modal-content-desktop">
        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column' }}>
          <div className="">
            <h1>UnderWriter Alt Login</h1>
          </div>
          <div className="" style={{ width: '400px' }}>
            <label>Username:</label>
            <input
              className="fake-cognito-username"
              id={'signInFormUsername'}
              value={this.state.username}
              type={'text'}
              onChange={(evt) => this.setState({ username: evt.target.value })}
            ></input>
            <label>Password(literally doesnt matter):</label>
            <input className="fake-cognito-password" id={'signInFormPassword'} type={'text'}></input>
          </div>
        </div>
        <div className="">
          <button
            style={{ width: '375px' }}
            className="btn btn-primary action-primary fake-cognito-login submitButton-customizable"
            onClick={() => this.setupFakeJWT()}
          >
            Login
          </button>
          <div className=".dark-sun-icon"></div>
        </div>
        <br />
        <div className={'redirect-customizable'} style={{ fontSize: 'x-small', color: 'lightgrey' }}>
          Forgot Password
        </div>
      </div>
    );
  }
}
